module.exports = __webpack_public_path__ + "img/9788992263238.2eb13086.jpg";